import type { Json, Satisfies } from '@yp/common/identity.ts';
import { hasKey, isObject, isString, pick } from '@yp/common/identity.ts';
import { BROWSER } from 'esm-env';
import { writable } from 'svelte/store';

export type VersionData = Satisfies<
  Json,
  {
    version: string;
  }
>;

const version = writable<string | undefined>();
export const Version = pick(version, 'subscribe');

export async function checkVersion(
  url: string,
  useFetch?: typeof fetch,
): Promise<VersionData | undefined> {
  useFetch ??= fetch;
  if (BROWSER) {
    const resp = await useFetch(url);
    const result = (await resp.json()) as Json;
    if (isObject(result) && hasKey(result, 'version', isString)) {
      version.set(result.version);
      return result;
    }
  }
  return undefined;
}
